import InspectionStatistic from './InspectionStatistic';

export default InspectionStatistic;
